import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="bg-white pt-32 pb-20 md:pt-40 md:pb-28 px-4 overflow-hidden" data-id="element-137">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-7 space-y-8" data-id="element-139">
          <div className="inline-block bg-primary/10 text-primary font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-140">
            Exclusivo para la mujer Latina en USA
          </div>

          <div className="space-y-4" data-id="element-141">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-142">
              Crea y Lanza tu Propio Negocio Digital con IA{' '}
              <span className="text-primary" data-id="element-143">en Menos de 48 Horas</span>
            </h1>

            <p className="text-xl md:text-2xl text-body leading-relaxed font-medium" data-id="element-144">
              Usando solo tu celular, sin aparecer en cámara y sin experiencia
              previa.
            </p>
          </div>

          <ul className="space-y-3 text-lg text-dark font-medium" data-id="element-145">
            {['Ideal para mamás latinas en USA', 'Acceso inmediato', 'Empieza hoy mismo'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-146">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0" data-id="element-147" />
                <span data-id="element-148">{item}</span>
              </li>)}
          </ul>

          <div className="pt-4" data-id="element-149">
            <motion.a href="https://www.vitarutinas.com/cart/50347583471862:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="shimmer-cta block w-full sm:w-auto bg-cta hover:bg-rose-600 text-white font-bold rounded-full px-8 py-5 text-lg shadow-xl shadow-cta/20 text-center relative overflow-hidden" animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.07
          }} whileTap={{
            scale: 0.97
          }} data-id="element-150">
              ¡Lanza Tu Negocio En 48 Horas! 🚀
            </motion.a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="lg:col-span-5 relative" data-id="element-151">
          <div className="relative rounded-[24px] overflow-hidden shadow-2xl border border-border group" data-id="element-152">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none" data-id="element-153"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mozDazfnqDLdMp54N9PFAe/portada.webp" alt="Sistema Mamá IA - Tu Negocio Digital en 48 Horas" className="w-full h-auto object-cover aspect-[4/5] transform group-hover:scale-105 transition-transform duration-700" data-id="element-154" />
            <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-155">
              <div className="bg-white/95 backdrop-blur-sm shadow-xl border border-white/20 rounded-[20px] p-5 transform translate-y-0 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-156">
                <p className="text-dark font-display font-bold text-xl mb-1" data-id="element-157">
                  Sistema Mamá IA
                </p>
                <p className="text-primary font-medium text-sm" data-id="element-158">
                  Tu negocio en piloto automático
                </p>
              </div>
            </div>
          </div>

          {/* Decorative elements for premium feel */}
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-primary/10 rounded-full blur-2xl -z-10" data-id="element-159"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-cta/10 rounded-full blur-2xl -z-10" data-id="element-160"></div>
        </motion.div>
      </div>
    </section>;
}